export default {
  format: {},
  autodetect: []
};